import { QueryClient } from "react-query";
import { exchange } from "@ls/js-fetch";

export const queryClient = new QueryClient();
export const DEFAULT_STALE_TIME = 3 * 60 * 60 * 1000;
export const DEFAULT_CACHE_TIME = DEFAULT_STALE_TIME;

// A utility function to fetch data with caching using react-query. Does not subscribe to updates as we are using reducers to manage state and updates.
export const fetchWithCache = async ({
  queryKey,
  baseURL,
  url,
  params,
  staleTime = DEFAULT_STALE_TIME,
  cacheTime = DEFAULT_CACHE_TIME,
  ...exchangeOptions
}) => {
  return queryClient.fetchQuery(
    queryKey,
    async () => {
      return (
        await exchange({
          baseURL,
          url,
          params,
          ...exchangeOptions,
        })
      )?.data.results;
    },
    { staleTime, cacheTime }
  );
};

export const fetchEntities = async ({
  asOfDate,
  asOfDateStart,
  distribution,
}) => {
  return fetchWithCache({
    queryKey: ["entities", asOfDate, asOfDateStart, distribution ?? ""],
    baseURL: process.env.REACT_APP_BASE_URL_ENTITY_ATTRIBUTES,
    url: "Attributes.json",
    params: {
      appName: process.env.REACT_APP_ID,
      entityDates: Array.from(new Set([asOfDate, asOfDateStart])),
      select: "distinct+entityId,name,benchmarkId,type,currency,minor,major,longName",
      relative: false,
      lookthru: false,
    },
  });
};

export const fetchSelectionSecurityAttributes = async ({
  asOfDateStart,
  asOfDate,
  groupType,
  identifiers,
}) => {
  return fetchWithCache({
    queryKey: ["selectionSecurityAttributes", asOfDateStart, asOfDate, groupType, identifiers],
    baseURL: process.env.REACT_APP_BASE_URL_ENTITY_ATTRIBUTES,
    url: "Security.json",
    params: {
      entityDates: Array.from(new Set([asOfDateStart, asOfDate])),
      select: "distinct+securityId,cusip9,isin,name,ticker,instrumentType,absMsaaSector,msaaBucketCode,msaaBucketDescription",
      appName: process.env.REACT_APP_ID,
      entityIds: identifiers,
      entityIdsType: groupType,
      orderBy: "name",
      lookthru: true,
    },
    dontSendBearerToken: false,
  });
};